<template>
  <v-navigation-drawer
    id="app-drawer"
    v-model="inputValue"
    app
    dark
    floating
    right
    persistent
    mobile-break-point="991"
    width="260"
  >
    <v-img
      height="100%"
    >
      <v-img
          :src="cphllogo"
          height="100"
          contain></v-img>
      <v-layout
        class="fill-height"
        tag="v-list"
        column
      >
      <v-list name="main_menu">
        <v-list-item>
          <v-list-item-title class="title">
            مختبر الصحة العامة المركزي
          </v-list-item-title>
        </v-list-item>
        <v-divider/>
        <v-list-item
          v-for="(link, i) in links"
          :key="i"
          :to="link.to"
          :active-class="color"
          class="v-list-item"
        >
          <v-list-item-action>
            <v-icon>{{ link.icon }}</v-icon>
          </v-list-item-action>
          <v-list-item-title
            v-text="link.text"
          />
        </v-list-item>
        <v-list-item
          active-class="success"
          class="v-list-item v-list__tile--buy"
          to="/help"
        >
          <v-list-item-action>
            <v-icon>mdi-package-up</v-icon>
          </v-list-item-action>
          <v-list-item-title class="font-weight-light">
            هل تحتاج الى مساعدة ؟
          </v-list-item-title>
        </v-list-item>

        <v-list-item
            active-class="success"
            class="v-list-item v-list__tile--buy"
            to="/logout"
        >
          <v-list-item-action>
            <v-icon>mdi-package-up</v-icon>
          </v-list-item-action>
          <v-list-item-title class="font-weight-light">
          تسجيل الخروج
          </v-list-item-title>
        </v-list-item>


      </v-list>
      </v-layout>
    </v-img>
  </v-navigation-drawer>
</template>

<script>
// Utilities
import {
  mapMutations,
  mapState
} from 'vuex'
import { __HTTP,FormHeader } from "@/utils/utils";

export default {
  props: {
    opened: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    cphllogo: 'assets/cphl-logo.png',
    logo: 'favicon.ico',
    links: [

    ]
  }),
  computed: {
    ...mapState('app', ['image', 'color']),
    inputValue: {
      get () {
        return this.$store.state.app.drawer
      },
      set (val) {
        this.setDrawer(val)
      }
    },
    items () {
      return this.$t('Layout.View.items')
    }
  },
  created() { this.getDrawer()},
  methods: {
    getDrawer() {
      __HTTP("?do=getdrawer",{id: this.$store.state.loggedUser.id},FormHeader,(res) => {
        res.map((i) => {
          if (i.type == 1)
            this.links.push({to: i.endpoint,icon: i.icon, text: i.title_ar});
        })

      });
    },
    ...mapMutations('app', ['setDrawer', 'toggleDrawer'])
  }
}
</script>
<style >

</style>
<style lang="scss">

  #app-drawer {
    .v-list__tile {
      border-radius: 4px;

      &--buy {
        margin-top: auto;
        margin-bottom: 17px;
      }
    }
  }
</style>
